export default __webpack_public_path__ + "static/media/teams-image.dcdb44c6.png";